<template>
  <div class="hero is-large is-dark">
    <div class="hero-body">
      <p class="title">
        <span class="material-symbols-outlined"> error</span>
        No Encontrado
      </p>
      <p class="subtitle">
        Parece que lo que estas necesitando no te lo podemos entregar, si deseas
        puedes regresar.
      </p>
      <a
        class="button is-info is-outlined"
        href="javascript:history.back()"
        title="Regresar"
      >
        Regresar
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
